module.exports = __webpack_public_path__ + "static/media/linkedin.66bcbb3a.svg";